import { gql } from '@apollo/client';
import {
  OfferingFieldsToCompare,
  PricingPlanFieldsToCompare,
  ScheduledChangesForEntitlementV2,
} from './scheduled-billing-changes-tab';
import { SubscribeToAddOnsFormData } from './subscribe-to-add-ons-form';

export const fetchEntitlementDetailsQuery = gql`
  ${SubscribeToAddOnsFormData}
  ${ScheduledChangesForEntitlementV2}
  ${OfferingFieldsToCompare}
  ${PricingPlanFieldsToCompare}
  query fetchEntitlementDetails($id: String) {
    entitlementDetails(id: $id) {
      addOns {
        totalCount
      }
      createdDate
      hasOpenInvoices
      billingFrequency: billingCycle
      billingStatus
      cloudSiteHostname
      cloudSiteCustomHostname
      cloudSiteId
      cloudSiteSen
      entitlementNumber
      updatePaymentMethodLink
      hasPendingInvoices
      nextInvoiceTimeAt
      invoices {
        nodes {
          id
        }
      }
      id
      endTimestamp
      latestPeriodEndDate
      latestPeriodStartDate
      transactionAccountId
      billingGroupId
      licenseLevel
      offeringId
      isOptOutAllowed
      version
      edition
      parentSen
      parentCloudSiteName
      platform
      productId
      productName
      baseProduct
      renewalAction
      sourceSystem
      plan
      subscriptionId
      unitCount
      upgradeTrial {
        baseOfferingName
        pricingPlan {
          type
          billingFrequency
          id
          currency
          pricingPlanType
          status
          description
          tiers {
            unitAmount
            flatAmount
            floor
            ceiling
          }
          chargeType
        }
        offering {
          id
          name
          trial {
            lengthDays
          }
          productKey
          level
          type
          pricingType
          status
          expiryDate
        }
        offeringId
        offeringName
        startTimestamp
        endTimestamp
      }
      nextBillEstimate {
        total
        currency
      }
      offering {
        id
        name
        productKey
        level
        type
        availableSyntheticPricingPlans {
          type
          status
          discountPercentage
        }
        pricingType
        trial {
          lengthDays
        }
        defaultPricingPlans {
          cycle {
            name
            interval
            count
          }
          currency
          key
          type
        }
        status
        expiryDate
      }
      promotions {
        id
        promotionCode
        title
        type
        benefits {
          benefitType
          duration
          subBenefitType
          iterations
          value
          scale
          type
          customisable {
            value {
              type
              lowerBound
              upperBound
            }
            iterations {
              type
              lowerBound
              upperBound
            }
            duration
          }
        }
        promotionInstanceId
        promotionWindow {
          endTime
          startTime
        }
        status
        cycleInterval
        pricingType
        eligibilityRules {
          products
          cycleInterval
          pricingType
          partnerType
          partnerTier
          saleTransitionType
          currency
        }
        cycleIntervalWithEligibleConditions
        applicationReason {
          id
          readableName
          customisable {
            id {
              type
              anyOf {
                readableName
                id
              }
            }
          }
        }
        isPromotionCustomisable
      }
      trialPromotionDetails {
        totalTrialDays
        totalTrialCount
      }
      subscriptionTimestamps {
        firstStartTimestamp
        lastEndTimestamp
        firstTrialStartTimestamp
        lastTrialEndTimestamp
      }
      offering {
        id
        name
      }
      pricingPlan {
        type
        billingFrequency
        id
        currency
        pricingPlanType
        status
        chargeType
        chargeElement
        description
        tiers {
          unitAmount
          flatAmount
          floor
          ceiling
        }
      }
      ...SubscribeToAddOnsFormData
      scheduledChanges {
        ...ScheduledChangesForEntitlementV2
      }
      activeSubscriptionBillingGroupId
      subscription {
        subscriptionPeriod {
          offeringKey
          startTimestamp
          chargeQuantities {
            chargeElement
            quantity
            lastUpdatedAt
          }
          trial {
            startTimestamp
            endTimestamp
            pricingPlanId
            offeringId
          }
        }
      }
      activeUsers
      totalBilledUsers
      provisioningStatus
      nextBillingTimestamp
      isSandbox
      isApp
      productType
      deletedProductDetails {
        status
        datePlaced
        deletedOn
        author
        supportTicket
        internalComment
      }
      relatesToEntitlements {
        entitlementId
        relationshipType
      }
      relatesFromEntitlements {
        entitlementId
        relationshipType
      }
      showExtendTrial
      productStatus
      logoId
      migrated
      userTier
    }
  }
`;
